import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import { Button } from '../components/ui/button';
import PasswordInput from '../components/PasswordInput';
import { apiService } from '../services/api';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await apiService.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'This link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      topRightCta={{ label: 'Log in', kind: 'ghost', onClick: () => navigate('/login') }}
    >
      {success ? (
        <div className="auth-center">
          <h1 className="auth-heading">
            Password <span className="auth-heading__accent">updated</span>
          </h1>
          <p className="auth-subheading">Your password has been reset. You can now log in.</p>
          <Button className="auth-btn-block" onClick={() => navigate('/login')}>
            Log in
          </Button>
        </div>
      ) : (
        <>
          <h1 className="auth-heading">
            Set new <span className="auth-heading__accent">password</span>
          </h1>
          <p className="auth-subheading">Choose a strong password for your account.</p>

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label" htmlFor="new_password">New password</label>
              <PasswordInput
                id="new_password"
                name="new_password"
                autoComplete="new-password"
                required
                className="auth-input"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setError(''); }}
              />
            </div>

            <div className="auth-field">
              <label className="auth-label" htmlFor="confirm_password">Confirm password</label>
              <PasswordInput
                id="confirm_password"
                name="confirm_password"
                autoComplete="new-password"
                required
                className="auth-input"
                placeholder="••••••••"
                value={confirm}
                onChange={(e) => { setConfirm(e.target.value); setError(''); }}
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <div className="auth-submit">
              <Button type="submit" className="auth-btn-block" disabled={loading}>
                {loading ? 'Saving…' : 'Set new password'}
              </Button>
            </div>
          </form>
        </>
      )}
    </AuthShell>
  );
};

export default ResetPasswordPage;
